(() => {
function $3eae2662c1474d25$var$registerLogin() {
    const formElem = document.getElementById('login_form');
    const loginErrorMsgElem = document.getElementById('login_error');
    formElem.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const resp = await fetch('/session', {
            method: 'POST',
            body: new FormData(formElem)
        });
        if (resp.redirected) window.location.replace(resp.url);
        else if (resp.status === 401) loginErrorMsgElem.textContent = 'Invalid username or password';
        else loginErrorMsgElem.textContent = 'Processing error';
    });
}
if (document.readyState === 'complete') $3eae2662c1474d25$var$registerLogin();
else document.addEventListener('DOMContentLoaded', $3eae2662c1474d25$var$registerLogin);

})();
//# sourceMappingURL=login.js.map
